import styled from 'styled-components';
import ButtonComponent from '../../BuildingBlocks/Button';
import SVGIcon from '../../SVGIcon';
import Text from '../../BuildingBlocks/Text';
import { mixins, colors } from '../../css';

const { pxToRem } = mixins;
const { colorWhite, iconGrey, colorGrey04 } = colors;
const { CopyParagraph } = Text;

export const getTheme = selected => (selected ? 'blue' : 'ghost');
export const getIconBackgroundColor = selected => (selected ? 'transparent' : colorWhite);
export const getIconColor = selected => (selected ? colorWhite : iconGrey);
export const getTextColor = selected => (selected ? 'secondary' : 'primary');

const Button = styled(ButtonComponent)`
  padding: ${pxToRem(5)} ${pxToRem(10)};
  display: flex;
  align-items: center;
  width: 100%;
  border: 1px solid ${({ selected }) => (selected ? 'transparent' : colorGrey04)};
`;

const Icon = styled(SVGIcon)`
  margin-left: ${({ mapLayer }) => (mapLayer ? 0 : pxToRem(15))};
  margin-right: ${({ mapLayer }) => (mapLayer ? pxToRem(10) : 0)};
  display: flex;
  align-items: center;
  padding: 2px;
  svg {
    max-height: ${pxToRem(20)};
    max-width: ${pxToRem(20)};
  }
`;

const Copy = styled(CopyParagraph)`
  font-size: ${pxToRem(12)};
`;

export default { Button, Icon, Copy };
